import React, { ReactNode, SyntheticEvent } from 'react'
import styled, { css } from 'styled-components'
import CreationToolFileType from '../../../../types/file-type'
import CreationToolOutputType from '../../../../types/output-type'
import CreationToolUIAnimation from '../../../../types/ui-animation'
import { StickerBlock } from '../../../blocks'
import VideoPlayer from '../../../video-player'
import { CreationToolUploadSource } from '../../types'

const TRANSPARENT_PIXEL =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

const Preview = styled.img`
    display: block;
    height: auto;
    width: 100%;
`

const Container = styled(StickerBlock)<{ isAbsolute: boolean }>`
    ${CreationToolUIAnimation.css(CreationToolUIAnimation.FadeIn)}

    ${({ isAbsolute }) =>
        isAbsolute &&
        css`
            position: relative;

            ${Preview} {
                height: 100%;
                object-fit: cover;
                left: 0;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }
        `}
`

type Props = {
    className?: string
    children?: ReactNode
    source: CreationToolUploadSource
    previewUrl?: string
}

const CreationUploadItemPreview = ({ className, source: uploadSource, previewUrl, children }: Props) => {
    if (!previewUrl) return null

    const { source, outputType } = uploadSource
    const isVideo = source.type === CreationToolFileType.VIDEO || source.type === CreationToolFileType.VIDEO_EMBED

    const onError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = TRANSPARENT_PIXEL
    }

    if (!children && outputType === CreationToolOutputType.Video) {
        return (
            <Container className={className} isAbsolute={false}>
                <VideoPlayer
                    {...{
                        source,
                        previewUrl,
                        width: 460,
                    }}
                />
            </Container>
        )
    }

    if (isVideo) {
        return (
            <Container className={className} isAbsolute={!!children}>
                <Preview as="video" src={previewUrl} muted autoPlay loop />
                {children}
            </Container>
        )
    }

    return (
        <Container className={className} isAbsolute={!!children}>
            <Preview src={previewUrl} onError={onError} />
            {children}
        </Container>
    )
}

export default CreationUploadItemPreview
